// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__33cBE","right":"styles_right__1TYj6"};